import { differenceInHours } from 'date-fns';

export function getDuration(startTime, endTime) {
  if (startTime === endTime) return 24;

  const hoursApart = differenceInHours(endTime, startTime);
  const duration = hoursApart < 0 ? 24 + hoursApart : hoursApart;

  return duration;
}
